import dayjs from '../config/dayjs';

export const SANTIAGO_TIMEZONE = 'America/Santiago';

export const DEFAULT_CALENDAR_MIN_DAYS_FROM_TODAY = 15;

export const MAX_DATE_TO_PAY_DAYS = 120;

export const TODAY = dayjs().startOf('day');

export const FOUR_MONTHS_FROM_TODAY = dayjs().add(4, 'months');

export const THREE_MONTHS_FROM_TODAY = dayjs().add(3, 'months');

export const monthsAgoDate = (months) => dayjs().subtract(months, 'month').format('YYYY-MM-DD');

export const daysFromTodayToDate = (days) => dayjs().add(days, 'days');

export const MAX_DATE_TO_PAY = daysFromTodayToDate(MAX_DATE_TO_PAY_DAYS);

export const formatDate = (date) => date.format('YYYY-MM-DD');

export const getDayDifference = (date1, date2) => {
  if (!date1 || !date2) return 0;
  const normalizedDate1 = date1.startOf('day');
  const normalizedDate2 = date2.startOf('day');
  return normalizedDate1.diff(normalizedDate2, 'day');
};

export const THIRTY_DAYS_AGO = dayjs().subtract(30, 'days');

export const TWO_MONTHS_AGO = dayjs().subtract(2, 'months');

export const UNTIL_FIFTEEN_DAYS = dayjs().add(15, 'days');

export const CURRENT_YEAR = dayjs().year();

export const areDatesEqual = (date1, date2) => {
  if (!date1 || !date2) return false;

  const dayjs1 = dayjs(date1);
  const dayjs2 = dayjs(date2);

  if (!dayjs1.isValid() || !dayjs2.isValid()) return false;

  return dayjs1.isSame(dayjs2, 'day');
};
